<script setup lang="ts">
import type { ExtendedPrimitives } from '@/types/ExtendedPrimitives'
import TableDetailRow from './TableDetailRow.vue'

type Props = {
    props: {
        row: Record<string, ExtendedPrimitives>
        index: number
    }
    stripable?: boolean
    classes?: string
    hasDetails?: boolean
}

defineProps<Props>()
</script>

<template>
    <TableDetailRow
        :hasDetails="hasDetails"
        :props="props"
        :class="props.index % 2 !== 0 ? 'striped-detail' : null"
        :key="props.index">
        <slot />
    </TableDetailRow>
</template>
